import React from 'react';

// Fade + slide reveal container using IntersectionObserver
export function Reveal({ children, delay = 0, className = '', as: Tag = 'div' }) {
  const ref = React.useRef(null);
  const [shown, setShown] = React.useState(false);

  React.useEffect(() => {
    if (!ref.current) return;
    const io = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setShown(true); io.disconnect(); } },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={className}
      style={{
        opacity: shown ? 1 : 0,
        transform: shown ? 'translateY(0)' : 'translateY(28px)',
        transition: `opacity 900ms cubic-bezier(0.22,1,0.36,1) ${delay}ms, transform 900ms cubic-bezier(0.22,1,0.36,1) ${delay}ms`,
      }}
    >
      {children}
    </Tag>
  );
}

export function SectionEyebrow({ children }) {
  return (
    <div className="flex items-center gap-4">
      <span className="inline-block w-10 h-px bg-[#C5A059]" />
      <span className="eyebrow">{children}</span>
    </div>
  );
}

export function ButtonPrimary({ children, ...rest }) {
  return (
    <button
      {...rest}
      className={`inline-flex items-center gap-2 rounded-full bg-[#002b5c] text-white px-7 py-3.5 text-[11px] tracking-[0.22em] uppercase transition-all duration-500 hover:bg-[#001a38] hover:-translate-y-0.5 hover:shadow-xl ${rest.className || ''}`}
    >
      {children}
    </button>
  );
}

export function ButtonGhost({ children, ...rest }) {
  return (
    <button
      {...rest}
      className={`inline-flex items-center gap-2 rounded-full border border-[#002b5c]/30 text-[#002b5c] px-7 py-3.5 text-[11px] tracking-[0.22em] uppercase transition-all duration-500 hover:border-[#002b5c] hover:bg-[#002b5c] hover:text-white ${rest.className || ''}`}
    >
      {children}
    </button>
  );
}
